import React, {
  Dispatch,
  memo,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';
import {
  PeriodFilterContext,
  periodFilterContextDefaultValue,
  PeriodFilterContextProps,
  PeriodFilterContextProvider,
} from 'src/components/domain/metrics/period-filter-context';

type DashboardFiltersContextProps = PeriodFilterContextProps & {
  targetUserId: number | undefined;
  setTargetUserId: Dispatch<SetStateAction<number | undefined>>;
};

export const DashboardFiltersContext = React.createContext<DashboardFiltersContextProps>({
  ...periodFilterContextDefaultValue,
  targetUserId: undefined,
  setTargetUserId: () => {},
});

type DashboardFiltersContextProviderProps = {
  children: React.ReactNode;
};

const DashboardTargetUserContextProvider = ({
  children,
}: DashboardFiltersContextProviderProps) => {
  const periodFilter = useContext(PeriodFilterContext);
  const [targetUserId, setTargetUserId] = useState<number | undefined>(undefined);

  const value = useMemo(
    () => ({ ...periodFilter, targetUserId, setTargetUserId }),
    [periodFilter, targetUserId],
  );

  return (
    <DashboardFiltersContext.Provider value={value}>
      {children}
    </DashboardFiltersContext.Provider>
  );
};

export const DashboardFiltersContextProvider = memo(
  ({ children }: DashboardFiltersContextProviderProps) => (
    <PeriodFilterContextProvider>
      <DashboardTargetUserContextProvider>{children}</DashboardTargetUserContextProvider>
    </PeriodFilterContextProvider>
  ),
);
